// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__l0CfM","selects":"Documents_selects__SSK66"};